import TagManager from 'react-gtm-module';
import { RouterProvider } from 'react-router';

import config from '@core/config';

import { AppProvider } from './contexts/AppContext';
import { AppRoutes } from './routes';

const { gaTrackingId } = config;
if (gaTrackingId) {
  TagManager.initialize({ gtmId: gaTrackingId });
}

const App = () => {
  return (
    <AppProvider>
      <RouterProvider router={AppRoutes()} />
    </AppProvider>
  );
};

export default App;
